export const NOT_LOADED = 0;
export const PLAYING = 1;
export const ENDED = 2;
export const ERROR = 3;
export const NO_STREAMS = 4;
export const VIDEOBREAK = 5;
export const TEST_SOURCE = 6;
export const AUTOPLAY_BLOCKED = 7;
